import { FC, HTMLAttributes } from "react";
import { simpleHash } from "src/utility";
import { useNavigate, useParams } from "react-router-dom";
import { JourneyType } from "src/Modules/Flights/constants";
import { getValues } from "src/utility/tree";
import { DERIVED_JOURNEY_TREE } from "./constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import JourneyCardWeb from "./layouts/JourneyCard.web";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import JourneyCardMobile from "./layouts/JourneyCard.mob";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { track } from "@amplitude/analytics-browser";

const JourneyCardComponent = withConditionalComponent(JourneyCardWeb, JourneyCardMobile);

const JourneyCard: FC<{
  journeyData: JourneyType;
} & HTMLAttributes<HTMLDivElement>> = ({
  journeyData,
  className,
  ...props
}) => {
  const navigate = useNavigate();
  const { searchId } = useParams();
  const { startedAt, maxTime } = useSelector((state: RootState) => state.timer);
  const { seatsAvailable, priceObject, miniRules, airline, imgUrl, isLcc, isRefundable, segments } = getValues(
    journeyData,
    DERIVED_JOURNEY_TREE,
  );
  const onClick = () => {
    const baseJSON = JSON.stringify(journeyData);
    const { hash } = simpleHash(baseJSON);
    const key = `ticket-${hash}`;
    localStorage.setItem(key, JSON.stringify({ ...journeyData, _session: { startedAt, maxTime } }));
    track("Flight Selected",{
      ...journeyData
    })
    navigate(`/travel/tickets/${searchId}/ticket/${key}`);
  };
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return (
    <div tabIndex={0} onClick={onClick} className="h-full w-full bg-background-default" {...props}>
      <JourneyCardComponent
        props={{ journeyData: journeyData, miniRules, priceObject, seatsAvailable, airline, imgUrl, isLcc, isRefundable, segments }}
        trigger={isLargeScreen}
      ></JourneyCardComponent>
    </div>
  );
};

export default JourneyCard;
